var map = {
	"./Delivery.svg": "qi84",
	"./cha.svg": "F50X",
	"./chatFile.svg": "6KCt",
	"./communicate.svg": "XqNn",
	"./top.svg": "jE4f",
	"./toudi.svg": "bSl5",
	"./xin.svg": "P8/x"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1